(function() {
  var containers = document.querySelectorAll('.pdp-delivery-estimate');
  for (var c = 0; c < containers.length; c++) {
    var wrap = containers[c];
    var productId = wrap.getAttribute('data-product-id');
    if (!wrap || !productId) continue;
  var cutoffHour = 12; // 12 PM (midday) UK cut-off
  var timezone = 'Europe/London';

  function isWeekday(d) {
    var day = d.getDay();
    return day !== 0 && day !== 6;
  }

  function getNextWorkingDay(fromDate) {
    var d = new Date(fromDate.getTime());
    d.setDate(d.getDate() + 1);
    while (!isWeekday(d)) {
      d.setDate(d.getDate() + 1);
    }
    return d;
  }

  function getNextWorkingDayCutoff(now) {
    var todayCutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutoffHour, 0, 0, 0);
    if (isWeekday(now) && now < todayCutoff) {
      return todayCutoff;
    }
    var next = getNextWorkingDay(now);
    return new Date(next.getFullYear(), next.getMonth(), next.getDate(), cutoffHour, 0, 0, 0);
  }

  function getDispatchStartDate(now) {
    var todayCutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutoffHour, 0, 0, 0);
    if (isWeekday(now) && now < todayCutoff) {
      return new Date(now.getFullYear(), now.getMonth(), now.getDate());
    }
    return getNextWorkingDay(now);
  }

  function addWorkingDays(fromDate, workingDays) {
    var d = new Date(fromDate.getTime());
    var added = 0;
    while (added < workingDays) {
      d.setDate(d.getDate() + 1);
      if (isWeekday(d)) added++;
    }
    return d;
  }

  function getDeliveryDateWithCutoff(offsetWorkingDays) {
    var now = new Date(new Date().toLocaleString('en-US', { timeZone: timezone }));
    var startDate = getDispatchStartDate(now);
    var deliveryDate = addWorkingDays(startDate, offsetWorkingDays);
    return deliveryDate.toLocaleDateString('en-US', { weekday: 'long', day: 'numeric', month: 'long' });
  }

  function toShortDate(fullDate) {
    return fullDate.replace('Tuesday', 'Tue').replace('Thursday', 'Thu').replace('Wednesday', 'Wed').replace('Monday', 'Mon').replace('Friday', 'Fri').replace('Saturday', 'Sat').replace('Sunday', 'Sun').replace('March', 'Mar').replace('April', 'Apr').replace('May', 'May').replace('June', 'Jun').replace('July', 'Jul').replace('August', 'Aug').replace('September', 'Sep').replace('October', 'Oct').replace('November', 'Nov').replace('December', 'Dec');
  }

  function initDates() {
    var rows = wrap.querySelectorAll('.delivery-option-row');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var offset = parseInt(row.getAttribute('data-offset'), 10);
      if (isNaN(offset)) continue;
      var fullDate = getDeliveryDateWithCutoff(offset);
      var shortDate = toShortDate(fullDate);
      row.setAttribute('data-full-date', fullDate);
      var dateEl = row.querySelector('.opt-date');
      if (dateEl) dateEl.textContent = shortDate;
    }
    var defaultActive = parseInt(wrap.getAttribute('data-default-active'), 10) || 2;
    var activeRow = wrap.querySelector('.delivery-option-row.active') || wrap.querySelector('.delivery-option-row[data-option="' + defaultActive + '"]') || wrap.querySelector('.delivery-option-row');
    if (activeRow) {
      var label = activeRow.getAttribute('data-label');
      var fullDate = activeRow.getAttribute('data-full-date');
      if (fullDate) {
        var typeEl = document.getElementById('pdp-delivery-type-' + productId);
        var dateEl = document.getElementById('pdp-delivery-date-' + productId);
        if (typeEl) typeEl.textContent = label || typeEl.textContent;
        if (dateEl) dateEl.textContent = 'Arrives by ' + fullDate;
      }
    }
  }

  function getOrderTimeRemaining() {
    var now = new Date(new Date().toLocaleString('en-US', { timeZone: timezone }));
    var targetTime = getNextWorkingDayCutoff(now);
    var diff = targetTime - now;
    var totalSeconds = Math.floor(diff / 1000);
    var days = Math.floor(totalSeconds / (24 * 60 * 60));
    var hours = Math.floor((totalSeconds % (24 * 60 * 60)) / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;
    return { days: days, hours: hours, minutes: minutes, seconds: seconds };
  }

  function updateTimers() {
    var time = getOrderTimeRemaining();
    var totalSeconds = time.days * 86400 + time.hours * 3600 + time.minutes * 60 + time.seconds;
    var timerEl = document.getElementById('pdp-desktop-timer-' + productId);
    if (!timerEl) return;
    if (totalSeconds <= 0) {
      timerEl.textContent = 'Tomorrow';
      return;
    }
    var parts = [];
    if (time.days > 0) parts.push(time.days + 'd');
    parts.push(time.hours + 'h');
    parts.push(String(time.minutes).padStart(2, '0') + 'm');
    timerEl.textContent = parts.join(' ');
  }

  function toggleTable() {
    var table = document.getElementById('pdp-delivery-table-' + productId);
    var link = document.getElementById('pdp-expand-link-' + productId);
    var bar = document.getElementById('pdp-delivery-bar-' + productId);
    if (!table || !link) return;
    var isOpen = table.classList.toggle('open');
    link.classList.toggle('expanded', isOpen);
    link.setAttribute('aria-expanded', isOpen);
    if (bar) bar.setAttribute('aria-expanded', isOpen);
  }

  function selectRow(row) {
    var rows = wrap.querySelectorAll('.delivery-option-row');
    for (var i = 0; i < rows.length; i++) rows[i].classList.remove('active');
    row.classList.add('active');
    var label = row.getAttribute('data-label');
    var fullDate = row.getAttribute('data-full-date');
    var typeEl = document.getElementById('pdp-delivery-type-' + productId);
    var dateEl = document.getElementById('pdp-delivery-date-' + productId);
    if (typeEl && label) typeEl.textContent = label;
    if (dateEl && fullDate) dateEl.textContent = 'Arrives by ' + fullDate;
  }

  initDates();
  updateTimers();
  setInterval(updateTimers, 1000);

  var bar = document.getElementById('pdp-delivery-bar-' + productId);
  var link = document.getElementById('pdp-expand-link-' + productId);
  if (bar) {
    bar.addEventListener('click', toggleTable);
    bar.addEventListener('keydown', function(e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleTable(); } });
  }
  if (link) link.addEventListener('click', function(e) { e.preventDefault(); toggleTable(); });

  var optionRows = wrap.querySelectorAll('.delivery-option-row');
  for (var j = 0; j < optionRows.length; j++) {
    optionRows[j].addEventListener('click', function() { selectRow(this); });
  }
  }
})();
